import { Wording } from '@/types';

export const COOKING_WORDING_LV: Wording = {
  components_header_media_content: 'Video par ēdienu gatavošanu',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Receptes',
  components_header_text2: 'Blogs',
  components_header_members: 'Dalībnieki',
  hero_text: 'Gatavojiet ar aizrautību, ēdiet ar prieku',
  hero_button_text: 'Sāciet gatavot jau šodien',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Visi resursi, kas nepieciešami, lai mācītos, gatavotu un radītu labāku ēdienu',
  components_ressources_span_text: 'Atklājiet bagātīgu video recepšu kolekciju, detalizētus gatavošanas ceļvežus un ekspertu ieskatus garšu saderībā, ēdienu pasniegšanā un kulinārijas radošumā.',
  components_ressources_card_1_title: 'Iedvesma ēdiena gatavošanai',
  components_ressources_card_1_text: 'Iedvesmojieties no radošām receptēm un gatavošanas video.',
  components_ressources_card_2_title: 'Pavārmākslas zināšanas',
  components_ressources_card_2_text: 'Apgūstiet svarīgākās gatavošanas tehnikas, garšu kombinācijas un ēdienu saderības pamatus, izmantojot skaidras, praktiskas rokasgrāmatas.',
  components_ressources_link: 'Skatīties video',
  components_notes_and_google_title_1: 'Pavārmākslas izglītība',
  components_notes_and_google_title_2: 'Ikdienas gatavošana',
  components_notes_and_google_title_3: 'Pastāvīgas gatavošanas prasmes',
  components_review_google_text: 'Atsauksmes pakalpojumā Google',
  media_content_section_title: 'Video par ēdienu gatavošanu',
  media_content_section_subheader_text: 'Iepazīstieties ar receptēm un soli pa solim gatavošanas video.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Vairāk video',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: 'Rokasgrāmatas un raksti',
  text2_section_button_more: 'Vairāk rakstu',
  components_text1_section_title: 'RECEPTES',
  components_text1_subheader_text: 'Gardas receptes ikdienas ēdiena gatavošanai',
  components_text1_span_text: 'Atklājiet viegli izpildāmas receptes, kas paredzētas ikdienas maltītēm, skaidriem soļiem un lieliskiem rezultātiem.',
  components_text1_card_1_title: 'Sāciet savu dienu pareizi',
  components_text1_card_1_text: 'Vienkāršas un garšīgas receptes, lai sāktu dienu viegli un ar garšu.',
  components_text1_card_3_title: 'Gardas pusdienu idejas',
  components_text1_card_3_text: 'Gardas pusdienu receptes, kas ir viegli pagatavojamas un pilnas ar garšu.',
  components_text1_card_2_title: 'Mierinošas vakariņu receptes',
  components_text1_card_2_text: 'Siltas, sātīgas vakariņu receptes, kas ir ideāli piemērotas relaksējošiem vakariem mājās.',
  components_text1_link: 'Skatīt visas receptes',
  components_footer_text: 'Mācies labāk gatavot, radi labāku ēdienu: tava virtuve, tavs ceļojums.',
  components_footer_info: 'Informācija',
  components_footer_registration_number: 'Reģistrācijas numurs',
  components_footer_legal: 'Juridiskā informācija',
  components_footer_terms: 'Noteikumi un nosacījumi',
  components_footer_privacy: 'Privātuma politika',
  button_load_more: 'Ielādēt vairāk',
  page_media_1_content_hero_text: 'Atklājiet vienkāršus ēdienu gatavošanas video katrai gaumei',
  page_text1_hero_text: 'Receptes',
  page_text1_section_title: 'Gatavošanas padomi',
  page_text1_subheader_text: 'Receptes',
  page_text2_hero_text: 'Mūsu emuārs',
  page_text2_section_title: 'Blogs',
  page_text2_subheader_text: 'Rokasgrāmatas un raksti',
  enter_email_title: 'Lūdzu, ievadiet savu e-pasta adresi, lai turpinātu',
  enter_email_placeholder_email: 'E-pasts',
  enter_email_button_enter: 'Ieiet',
  components_login_success_text: 'Pieteikšanās veiksmīga!',
  components_card_link_media_content: 'Skatīties tūlīt',
  components_card_link_text1_content: 'Skatīt recepti',
  components_card_link_text2_content: 'Skatīt rakstu',
};